import { Component } from 'base/js/aem';

class layeredParallax extends Component {
    init() {
        // grab all the layers
        this.stage = this.element.querySelector('.layeredParallax-stage');
        this.layers = this.stage?.querySelectorAll('.item');
        if (!this.layers?.length) {
            return;
        }

        this.speedMultiplier = 0.1;
        this.direction = this.getDirection();
        this.timing = this.element.dataset.animationTiming || 'top';

        // compute trigger point once
        const rect = this.element.getBoundingClientRect();
        const pageY = window.pageYOffset || document.documentElement.scrollTop;

        if (this.timing === 'bottom') {
            // start when top of element reaches bottom of viewport
            this.triggerPoint = rect.top + pageY - window.innerHeight;
        } else {
            // start when top of element reaches top of viewport
            this.triggerPoint = rect.top + pageY;
        }

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll);
        this.onScroll(); // initial check
    }

    getDirection() {
        if (this.element.classList.contains('dirUp')) {
            return 'up';
        }
        if (this.element.classList.contains('dirLeft')) {
            return 'left';
        }
        if (this.element.classList.contains('dirRight')) {
            return 'right';
        }
        return 'down';
    }

    onScroll() {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const offset = scrollY - this.triggerPoint;
        if (offset <= 0) {
            return;
        }

        this.layers.forEach(layer => {
            const speed = parseFloat(layer.dataset.speed) || 0;
            const distance = offset * speed * this.speedMultiplier;
            layer.style.transform = this._makeTransform(distance);
        });
    }

    _makeTransform(distance) {
        switch (this.direction) {
        case 'up':
            return `translate3d(0, -${distance}px, 0)`;
        case 'down':
            return `translate3d(0, ${distance}px, 0)`;
        case 'left':
            return `translate3d(${distance}px, 0, 0)`;
        case 'right':
            return `translate3d(-${distance}px, 0, 0)`;
        default:
            return 'translate3d(0, 0, 0)';
        }
    }
}

export { layeredParallax };
